import { client } from '../client';
import { Address, UserProfile } from './types/UserProfile';
export { fullNameFromFirstAndLast } from '../../../default/services/identity/createNewUser';

export type CreateUserPayload = {
  email?: string;
  address?: Address;
  phone_number?: string;
  type?: string;
  organization_ids?: string[];
  division_ids?: string[];
  practice_ids?: string[];
  send_invitation?: boolean;
  full_name?: string;
  frontend_website?: string;
  is_quick_add?: boolean;
  client_ids?: number[];
  /** Patient/Dependent only, and only when exactly one client_id is sent. Max 40 characters, enforced by the backend. */
  external_id?: string;
};

export type CreateNewUserOptions = {
  useSuperAdminEndpoint?: boolean;
};

export const createNewUser = async (
  payload: CreateUserPayload,
  options?: CreateNewUserOptions,
): Promise<UserProfile> => {
  const path = options?.useSuperAdminEndpoint ? '/superadmin/users' : '/admin/users';
  const { data } = await client.post<UserProfile>(path, payload);

  return data;
};
